import { Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular/standalone';
import { SHARED_STANDALONE_IMPORTS } from 'app/shared/standalone-imports';

@Component({
  selector: 'app-home-navigation-bar',
  templateUrl: './home-navigation-bar.component.html',
  styleUrls: ['./home-navigation-bar.component.scss'],
  standalone: true,
  imports: [...SHARED_STANDALONE_IMPORTS],
})
export class HomeNavigationBarComponent {
  router = inject(Router);
  private modalCtrl = inject(ModalController);

  @Input() isLoggedIn = false;

  public cancel() {
    return this.modalCtrl.dismiss(null, 'close');
  }
}
